module.exports = __webpack_public_path__ + "img/8-itol-default-view.755973e7.png";